import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "src/redux/reducers";
import { setOpenAddBriefPane } from "src/redux";
import useGetProjectBriefData from "src/app/project/hooks/useGetProjectBriefData";
import FilePreviewDisplay from "src/app/components/FilePreviewDisplay/FilePreviewDisplay";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

interface ProjectBriefPreviewProps {
  briefNameMaxWidth?: number;
}

export default function ProjectBriefPreview({
  briefNameMaxWidth,
}: ProjectBriefPreviewProps) {
  const { isLoadingBrief } = useSelector(
    (state: RootState) => state.projectReducer,
  );

  const dispatch = useDispatch();
  const { briefName, briefContent } = useGetProjectBriefData();

  const handleOpenAddBriefPane = () => {
    dispatch(setOpenAddBriefPane(true));
  };

  const shouldDisplayPreview = Boolean(briefName) || Boolean(briefContent);

  return (
    <FilePreviewDisplay
      isLoading={isLoadingBrief}
      fileName={briefName}
      shouldDisplayPreview={shouldDisplayPreview}
      fileNameMaxWidth={briefNameMaxWidth}
      onOpenPreview={handleOpenAddBriefPane}
      label={
        <IDHFormattedMessage
          id="ws_campaign_brief"
          defaultMessage="Campaign brief"
        />
      }
    />
  );
}
